import PlansBasedOnCountryService from "../../Services/PlansBasedOnCountryService";

const getSubPlanList = async (modalData) => {
    let setSubPlanDetails = {
        subPlanList: [],
        plansFound: 0,
        message: ''
    };

    try {
        console.log("Received data:", modalData.planId); // Log the data to check the structure

        // Wait for the response
        const response = await PlansBasedOnCountryService.getPlanByPlanId(modalData.planId);
        console.log("Received response:", response); // Log the response to check the structure

        if (response.status === 200) {
            setSubPlanDetails = {
                subPlanList: response.data,
                plansFound: 1,
                message: ''
            };
        } else {
            setSubPlanDetails = {
                subPlanList: [],
                plansFound: 0,
                message: 'No Plans Available'
            };
        }
    } catch (error) {
        if (error.message === "Network Error") {
            setSubPlanDetails = {
                subPlanList: [],
                plansFound: 0,
                message: 'Network Error'
            };
        } else {
            const status = error.response ? error.response.status : "";
            switch (status) {
                case 401:
                case 403:
                case 404:
                case 406:
                case 500:
                    setSubPlanDetails = {
                        subPlanList: [],
                        plansFound: 0,
                        message: 'No Plans Available'
                    };
                    break;
                default:
                    setSubPlanDetails = {
                        subPlanList: [],
                        plansFound: 0,
                        message: 'Unknown Error'
                    };
                    break;
            }
        }
    }

    console.log("Final data:", setSubPlanDetails); // Log the final structure
    return setSubPlanDetails;
};

export default getSubPlanList;
